import { Navigate, Outlet, useLocation } from "react-router-dom";
import useAuthStore from "../store/authStore";

export default function ProtectedRoute({ role }) {
  const seekerToken = useAuthStore((s) => s.seekerToken);
  const seekerUser = useAuthStore((s) => s.seekerUser);
  const employerToken = useAuthStore((s) => s.employerToken);
  const employerUser = useAuthStore((s) => s.employerUser);

  const location = useLocation();

  if (role === "employer") {
    if (!employerToken)
      return (
        <Navigate
          to={`/employers/login?next=${encodeURIComponent(location.pathname + location.search)}`}
          replace
        />
      );
    if (!employerUser) return null;
    if (!employerUser.is_verified && !location.pathname.includes("verify")) {
      return (
        <Navigate
          to={`/employers/verify-pending?email=${encodeURIComponent(employerUser.email)}`}
          replace
        />
      );
    }
    return <Outlet />;
  }

  if (!seekerToken)
    return (
      <Navigate
        to={`/login?next=${encodeURIComponent(location.pathname + location.search)}`}
        replace
      />
    );
  if (!seekerUser) return null;
  if (!seekerUser.is_verified && !location.pathname.includes("verify")) {
    return (
      <Navigate
        to={`/verify-pending?email=${encodeURIComponent(seekerUser.email)}`}
        replace
      />
    );
  }
  return <Outlet />;
}
